import { useHttpClient} from "@/common/api/httpClient";
import type { ShapeResponse } from "./models/shapeResponse";
import { processShape } from "../domain/processShape";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface ListShapeResponse {
  ok: true;
  shapes: ShapeResponse[];
}

export function useListShapes() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('shape'), {
      headers
    });

    const text = translations.value.shapes.actions.fetchMany;

    const response = await httpClient.action<ListShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const shapes = await response.json() as ShapeResponse[];

        for (const shape of shapes) {
          processShape(shape);
        }

        return {
          ok: true,
          shapes: shapes
        };
      },
    });

    return response;
  }
}


